export default {
    name: 'fw-open-local-file',
    fragment: {
        template: `
        <xbutton
          class="convert-item fv__ui-toolbar-show-text-button fw__fw-open-local-file"
          name="fw-open-local-file"
          @tooltip
          tooltip-title="打开文件"
          icon-class="fv__icon-toolbar-open"
          @Controller="file:OpenLocalFileController"
          file-selector
          @cannotBeDisabled
        >
        </xbutton>
        `,
        config: [{
            target: 'fw-open-local-file',
            isFileSelector: true,
        }]
    }
};